import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SignIn } from 'src/app/models/User/SignIn.model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { InvalidFieldMessageService } from 'src/app/services/invalid-field-message/invalid-field-message.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-signIn',
  templateUrl: './signIn.page.html',
  styleUrls: ['./signIn.page.scss'],
  providers: []
})
export class SignInPage {
  public hide: boolean = true;
  loginFormGroup: FormGroup;
  public loading: boolean = false;
  public accountInactive: boolean = false;
  public inactiveMessage: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private messageService: InvalidFieldMessageService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private sessionService: SessionService) {
    this.authenticationService.verifyIfIsLogged();
    this.loginFormGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(5), Validators.email]],
      password: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(8)]]
    });
  }

  get message() {
    return this.messageService
  }

  get form() {
    return this.loginFormGroup.controls;
  }

  public errorMessageEmail(): string {
    return ''
  }

  private createObject(): SignIn {
    return {
      email: this.form['email'].value,
      password: this.form['password'].value
    }
  }

  public async signup() {
    this.loading = true;
    try {
      if (this.loginFormGroup.invalid) {
        return;
      }

      const r = await this.authenticationService.signIn(this.createObject())
      if (r.success) {
        if (this.sessionService.getDetails().wizardFinished)
          this.router.navigate(['/home']);
        else
          this.router.navigate(['/wizard']);
        return;
      }

      if (r.messageCode == -4) {
        this.accountInactive = true;
        this.inactiveMessage = r.data;
        return;
      }

      throw(r);
    } catch (err) {
      this.snackBar.open(this.translateService.instant("signIn.invalidLogin"), '', {
        duration: 10000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
    } finally {
      this.loading = false;
    }
  }
}